
import DrawBase from "./DrawBase"
import ConstantDraw from "../constants/ConstantDraw"
import * as PlotUtils from "./utils/utils2d"
import * as Constants from "./utils/Constants"
class DrawSector extends DrawBase {

    constructor(options) {
        super(options);
        this.options = options;
        this.lastX_m = undefined;
        this.lastY_m = undefined;//记录鼠标位置
        this.dir_m = 1; //正向顺时针
    }

    //左键
    leftClick(evt) {
        this.lastX_m = undefined;
        this.lastY_m = undefined;//记录鼠标位置
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if (!position) {
            return;
        }
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        if ($this.positions.length <= 2) {
            $this.positions.push(position);
        }
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.lastX_m && $this.lastY_m) {
            var deltaX = evt.endPosition.x - $this.lastX_m;
            var deltaY = evt.endPosition.y - $this.lastY_m;
            var angle = Math.atan2(deltaY, deltaX) * 180 / Math.PI;
            this.dir_m = angle >= 0 ? 1 : -1;
        }
        $this.lastX_m = evt.endPosition.x;
        $this.lastY_m = evt.endPosition.y;

        var cartesian = $this.getCatesian3FromPX(evt.endPosition);
        if (!cartesian) {
            return;
        }
        $this.positions.pop();
        $this.positions.push(cartesian);

        if ($this.positions.length <= 2) {
            return;
        }
        if (!$this.Cesium.defined($this.plot)) {
            $this.plot = $this.createSector($this.positions);
            $this.entities.push($this.plot);
            //$this.editHelp = new EditPolygon(this.options); //初始化编辑类
        }
    }
    computeSector(positions) {
        var $this = this;
        var arr = [];
        var c = positions[0];
        var p1 = positions[1];
        var p2 = positions[2];
        var center = $this.cartesianToLatlng(c);
        var firstPoint = $this.cartesianToLatlng(p1);
        var endPoints = $this.cartesianToLatlng(p2);
        var startAngle = PlotUtils.getAzimuth(firstPoint, center);
        var endAngle = PlotUtils.getAzimuth(endPoints, center);
        //优化绘制大扇形时像椭圆的问题
        var d_1 = startAngle * 180 / 3.14;
        var d_2 = endAngle * 180 / 3.14;
        var r1 = this.distanceMeter(firstPoint, center);
        var pList = this.generatSectorPoints(center, r1, d_1, d_2);
        pList.push(center, pList[0]);
        for (var i = 0; i < pList.length; i++) {
            var p = pList[i];
            var cart3 = $this.Cesium.Cartesian3.fromDegrees(p[0], p[1], 0);
            arr.push(cart3);
        }
        return arr;

    }
    //计算两个点的距离
    distanceMeter(lngLat1, lngLat2) {
        var radLat1 = lngLat1[1] * Math.PI / 180.0;
        var radLat2 = lngLat2[1] * Math.PI / 180.0;
        var a = radLat1 - radLat2;
        var b = lngLat1[0] * Math.PI / 180.0 - lngLat2[0] * Math.PI / 180.0;
        var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * 6378.137;
        s = Math.round(s * 10000) / 10;
        return s
    }
    //获取一个圆的边缘坐标
    generatSectorPoints(center, radius, startAngle, endAngle) {
        startAngle = 90 - startAngle;
        endAngle = 90 - endAngle;
        let points = [];
        if (startAngle < endAngle ) {
            for (let i = startAngle; i < endAngle; i += 2) {
                points.push(this.getCirclePoint(center[0], center[1], i, radius))
            }
        } else {
            for (let i = startAngle; i > endAngle; i -= 2) {
                points.push(this.getCirclePoint(center[0], center[1], i, radius))
            }
        }
        return points;
    }
    getCirclePoint(lon, lat, angle, radius) {
        let dx = radius * Math.sin(angle * Math.PI / 180.0);
        let dy = radius * Math.cos(angle * Math.PI / 180.0);
        let ec = Constants.PRADIUS + (Constants.ERADIUS - Constants.PRADIUS) * (90.0 - lat) / 90.0;
        let ed = ec * Math.cos(lat * Math.PI / 180);
        let newLon = (dx / ed + lon * Math.PI / 180.0) * 180.0 / Math.PI;
        let newLat = (dy / ec + lat * Math.PI / 180.0) * 180.0 / Math.PI;
        return [newLon, newLat];
    }
    createSector(positions) {
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.computeSector(positions));
        }, false);

        var arrowEntity = this.viewer.entities.add({
            polygon: {
                hierarchy: hierarchyProperty,
                ...this.unionStyle(ConstantDraw.Style_PolygonNor)
            }
        });
        return arrowEntity
    }
    getPointOnCircle(x0, y0, radius, angleInDegrees) {
        var angleInRadians = angleInDegrees * Math.PI / 180;
        var x = x0 + radius * Math.cos(angleInRadians);
        var y = y0 + radius * Math.sin(angleInRadians);
        return [x, y];
    }
}

export default DrawSector